import {IconButton} from '@wandb/components';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import * as Tooltip from '@wandb/weave/components/RadixTooltip';
import React from 'react';

type OverflowMenuProps = {
  children: React.ReactNode;
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
  buttonSize?: 'sm' | 'md' | undefined;
};

export const PanelOverflowMenu = ({
  isMenuOpen,
  setIsMenuOpen,
  children,
  buttonSize = 'sm',
}: OverflowMenuProps) => {
  return (
    <Tooltip.Provider>
      <DropdownMenu.Root
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
        modal={false} // Setting this to false so it doesn't interfere with focus
      >
        <DropdownMenu.Trigger asChild>
          <IconButton
            isActive={isMenuOpen}
            onPress={e => {
              e.continuePropagation();
              setIsMenuOpen(true);
            }}
            onKeyDown={event => {
              // Keep app shortcuts available while this react-aria trigger has focus.
              event.continuePropagation();
            }}
            icon="overflow-horizontal"
            variant="ghost"
            aria-label="More panel actions"
            data-dd-action-name="More panel actions"
            size={buttonSize}
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>{children}</DropdownMenu.Portal>
      </DropdownMenu.Root>
    </Tooltip.Provider>
  );
};
